const FEATURE_HELP_URLS = {
  agent_bots: 'https://omnup.com',
  agents: 'https://omnup.com',
  audit_logs: 'https://omnup.com',
  campaigns: 'https://omnup.com',
  canned_responses: 'https://omnup.com',
  channel_email: 'https://omnup.com',
  channel_facebook: 'https://omnup.com',
  custom_attributes: 'https://omnup.com',
  dashboard_apps: 'https://omnup.com',
  help_center: 'https://omnup.com',
  inboxes: 'https://omnup.com',
  integrations: 'https://omnup.com',
  labels: 'https://omnup.com',
  macros: 'https://omnup.com',
  reports: 'https://omnup.com',
  sla: 'https://omnup.com',
  team_management: 'https://omnup.com',
  webhook: 'https://omnup.com',
  billing: 'https://omnup.com',
  saml: 'https://omnup.com',
  captain: 'https://omnup.com',
  captain_billing: 'https://omnup.com',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
